module.exports = __webpack_public_path__ + "img/menuIcon5.6f9dafb1.png";